import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface IDevSettingsStore {
  enabled: boolean
  setEnabled: (value: boolean) => void
  permissions: null | 'portalUser' | 'portalAdmin' | 'managementUser' | 'managementAdmin' | 'apiUser' | 'apiAdmin'
  setPermissions: (value: null | 'portalUser' | 'portalAdmin' | 'managementUser' | 'managementAdmin' | 'apiUser' | 'apiAdmin') => void
  isMonitoringCentre: null | boolean
  setIsMonitoringCentre: (value: null | boolean) => void
}

export const useDevSettingsStore = create<IDevSettingsStore, [['zustand/persist', unknown]]>(
  persist(
    (set, get) => ({
      enabled: false,
      setEnabled: (value) => set({ enabled: value }),
      permissions: null,
      setPermissions: (value) => set({ permissions: value }),
      isMonitoringCentre: null,
      setIsMonitoringCentre: (value) => set({ isMonitoringCentre: value })
    }),
    {
      name: 'app-dev'
    }
  )
)
